import { Accordion, AccordionDetails, styled, Theme } from '@material-ui/core';
import { getCompletionColor } from 'pages/Representatives/utils/getCompletionColor';
import { CircularProgressbar } from 'react-circular-progressbar';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_CONTAINER_FIELDS_FLOATING,
  DARK_FIELDS_ON_CARD_HEADER_LINE,
  DARK_TEXT,
  GRAY_CIRCULAR_PROGRESS_BACKGROUND,
  LIGHT_CONTAINER_FIELDS_FLOATING,
  LIGHT_HEADER_LINE,
  PLAIN_TEXT,
  PRIMARY_BUTTON_BORDER,
} = COLORS;

export const EditProfileMediaDocumentAccordionContainer = styled(Accordion)(({ theme }) => ({
  backgroundColor: theme.palette.type === 'dark' ? DARK_CONTAINER_FIELDS_FLOATING : LIGHT_CONTAINER_FIELDS_FLOATING,
  borderRadius: 8,
  boxShadow: 'none',
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: '12px 0',
  },
  padding: 5,
}));

export const EditProfileMediaDocumentProgressBar = styled(CircularProgressbar)(
  ({ theme, completeness = 0 }: { theme: Theme; completeness: number }) => ({
    overflow: 'hidden',
    color: 'white',
    display: 'flex',
    width: 25,
    // Modify the path color dynamically
    '& .CircularProgressbar-path': {
      stroke: getCompletionColor(completeness),
    },

    // Modify the text color based on the theme
    '& .CircularProgressbar-text': {
      fill: theme.palette.type === 'dark' ? 'white' : 'black',
    },

    // Modify the trail color based on the theme
    '& .CircularProgressbar-trail': {
      stroke: theme.palette.type === 'dark' ? GRAY_CIRCULAR_PROGRESS_BACKGROUND : GRAY_CIRCULAR_PROGRESS_BACKGROUND,
    },
  }),
);

export const EditProfileAccordionSummaryLeft = styled('aside')(({ theme }) => ({
  display: 'flex',
  gap: 10,
  alignItems: 'center',
  '& svg': {
    width: 30,
  },
  '& .MuiTypography-root': {
    fontSize: '10px',
  },

  [theme.breakpoints.up('md')]: {
    '& svg': {
      width: '40px',
      height: '40px',
    },
    '& .MuiTypography-root': {
      fontSize: '14px',
    },
  },
}));

export const EditProfileAccordionSummaryRight = styled('aside')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: 10,
  flex: 1,
  justifyContent: 'end',
}));

export const EditProfileAccordionSummaryRightButtonContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  marginLeft: 'auto',
  gap: 10,
  '& .MuiButton-root': {
    width: 150,
    border: `1px solid ${PRIMARY_BUTTON_BORDER}`,
    textTransform: 'uppercase',
  },
  '& .MuiButton-outlinedPrimary': {
    backgroundColor: 'transparent',
    color: theme.palette.type === 'dark' ? PLAIN_TEXT : DARK_TEXT,
  },
}));

export const EditProfileMediaDocumentAccordionDetails = styled(AccordionDetails)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: `1px solid ${theme.palette.type === 'dark' ? DARK_FIELDS_ON_CARD_HEADER_LINE : LIGHT_HEADER_LINE}`,
}));

export const EditProfileMediaProgressBarContainerLarge = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    width: 150,
  },
  [theme.breakpoints.up(1420)]: {
    width: 200,
  },
}));
